import {
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
} from '@mui/material'
import React from 'react'
import { useProjectFeaturesContext } from '../project/contexts/ProjectFeaturesContext'
import { useNavigate } from 'react-router-dom'
import { ConsentProvider } from '../EmployeeToolsMenu/Attendance/ConsentContext'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { SignOnDialog } from '../EmployeeToolsMenu/Attendance/SignOnDialog'
import { SignOutDialog } from '../EmployeeToolsMenu/Attendance/SignOutDialog'
import { CardSignOnDialog } from '../EmployeeToolsMenu/Attendance/CardSignOnDialog'
import { CardSignOutDialog } from '../EmployeeToolsMenu/Attendance/CardSignOutDialog'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
import ScheduleIcon from '@mui/icons-material/Schedule'

export const ManageLTWorkersDialog = () => {
	const [open, setOpen] = React.useState(false)
	const [currentStep, setCurrentStep] = React.useState(1)
	const navigate = useNavigate()
	const { isFeatureEnabled } = useProjectFeaturesContext()
	const handleClickOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		setOpen(true)
	}
	const handleClose = () => {
		setOpen(false)
		setCurrentStep(1)
	}

	const handleShiftEndReport = () => {
		handleClose()
		navigate('/ltReports')
	}
	return (
		<>
			<Button
				onClick={handleClickOpen}
				title='Tools'
				color='primary'
				sx={{ mr: 4, mt: 1, minWidth: '3rem' }}
				variant='outlined'
			>
				<ManageAccountsIcon sx={{ fontSize: '1.6rem' }} color='primary' />
			</Button>
			<ConsentProvider>
				<Dialog
					open={open}
					onClose={handleClose}
					maxWidth={
						currentStep === 1 ? 'xs' : currentStep === 3 && !isFeatureEnabled(2) ? 'sm' : 'lg'
					}
					fullWidth
				>
					<div
						onClick={(e: React.MouseEvent<HTMLDivElement>) => {
							e.stopPropagation()
						}}
					>
						<DialogTitle>
							{currentStep !== 1 && (
								<IconButton color='default' onClick={() => setCurrentStep(1)} sx={{ mr: 1 }}>
									<ArrowBackIcon />
								</IconButton>
							)}
							{currentStep === 1
								? 'Manage Line Techs'
								: currentStep === 2
								? 'Sign In'
								: currentStep === 3
								? 'Sign Out'
								: 'Shift End Report'}
						</DialogTitle>
						<IconButton
							onClick={handleClose}
							sx={(theme) => ({
								position: 'absolute',
								right: 8,
								top: 8,
								color: theme.palette.grey[500],
							})}
						>
							<CloseIcon />
						</IconButton>

						{currentStep === 1 ? (
							<DialogContent sx={{ height: 'auto' }}>
								<List>
									<ListItem divider sx={{ width: '100%' }}>
										<ListItemButton onClick={() => setCurrentStep(2)}>
											<ListItemIcon>
												<LoginIcon />
											</ListItemIcon>
											<ListItemText primary={'Sign In'} />
										</ListItemButton>
									</ListItem>
									<ListItem divider sx={{ width: '100%' }}>
										<ListItemButton onClick={() => setCurrentStep(3)}>
											<ListItemIcon>
												<LogoutIcon />
											</ListItemIcon>
											<ListItemText primary={'Sign Out'} />
										</ListItemButton>
									</ListItem>
									<ListItem divider sx={{ width: '100%' }}>
										<ListItemButton onClick={handleShiftEndReport}>
											<ListItemIcon>
												<ScheduleIcon />
											</ListItemIcon>
											<ListItemText primary={'Shift End Report'} />
										</ListItemButton>
									</ListItem>
								</List>
							</DialogContent>
						) : currentStep === 2 ? (
							!isFeatureEnabled(2) ? (
								<SignOnDialog handleClose={handleClose} open={currentStep === 2} department='LT' />
							) : (
								<CardSignOnDialog open={currentStep === 2} department='LT' />
							)
						) : currentStep === 3 ? (
							!isFeatureEnabled(2) ? (
								<SignOutDialog
									handleClose={handleClose}
									open={currentStep === 3}
									department='LT'
								/>
							) : (
								<CardSignOutDialog open={currentStep === 3} department='LT' />
							)
						) : null}
					</div>
				</Dialog>
			</ConsentProvider>
		</>
	)
}
